const responseSuccessInterceptor = (response) => response.data;

export default responseSuccessInterceptor;
